import { Injectable } from '@angular/core';
import { FirebaseStorage, getDownloadURL, getStorage, percentage, ref, uploadBytesResumable, UploadTask } from "@angular/fire/storage";
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FileDbService } from './file-db.service';

export interface UploadState {
  state: "running" | "success" | "canceled" | "error" | "paused" | "inactive" | 'saved';
  progress: number;
  file: any;
}


@Injectable(
)
export class FileUploadService {
  file: any;
  // file: FileModel;
  storage:FirebaseStorage;
  _uploadState = new BehaviorSubject<UploadState>({state: "inactive", progress: 0, file: null})
  uploadState$ = this._uploadState.asObservable();
  uploadTask: UploadTask;
  hasError=false;
  constructor(
    private fileDbService: FileDbService,
  ) { 
    this.storage = getStorage();
  }

  init(){
  }

  uploadFile(file2Upload, basePath, collection, options=null){
    const {extra} = options ? options : {extra:{}};
    const fileId = this.fileDbService.createId();
    const path = `${basePath}/${fileId}/${file2Upload.name}`;
    const storageRef = ref(this.storage,path);

    //se crea el archivo base
    const file = {
      path,
      name: file2Upload.name,
      size: file2Upload.size,
      version: 0,
      contentType: file2Upload.type,
      ...extra
    };

    this.uploadTask = uploadBytesResumable(storageRef, file2Upload);
  
    percentage(this.uploadTask)
      .pipe(map(s => {
        return {
          state: s.snapshot.state,
          progress: Math.round(s.progress),
          file
        } as UploadState    
      })
    ).subscribe(val=> this._uploadState.next(val))

    this.uploadTask
    .then(res => getDownloadURL(res.ref))
    .then(url => {
      file.url = url;
      return this.fileDbService.create( fileId, file, collection);
    })
    .then(_ => { 
      this.fileSaved(file);
    })
    .catch(err=>{
      this.hasError = true;
      console.error("Upload File Error", err);
    })
  }

  fileSaved(file){
    this._uploadState.next({
      state: "saved",
      progress: 99,
      file
    })
  }

  cancelUpload(){
    const currentState = this._uploadState.value;
    this._uploadState.next({...currentState,  state: "canceled"})
    this.uploadTask.cancel();
  }
  
}
